jQuery(document).ready(function($) {
    // Function to handle scrolling to elements
    function scrollToElement(targetElement) {
        // Get the height of your fixed header (adjust this value if necessary)
        var headerHeight = $('header').outerHeight() || 0;  // Fallback to 0 if there's no header element
    
        // Add a 20px offset to the scroll position
        var offset = headerHeight + 25;
    
        // Scroll to the target element with the offset (taking header into account and adding 20px space)
        $('html, body').animate({
            scrollTop: targetElement.offset().top - offset
        }, 500);
    }
    

    // Function to open a tab (expand its content)
    function openTab(targetElement) {
        var icon = targetElement.find('.tab-toggle-icon');
        var target = $(targetElement).data('target');
        var isExpanded = targetElement.attr('aria-expanded') === 'true';

        // Toggle the tab content and the aria-expanded attribute
        $(target).toggle();
        targetElement.toggleClass('expanded');
        
        // Toggle the icon between plus and minus
        if (isExpanded) {
            targetElement.attr('aria-expanded', 'false');
            icon.text('+');  // Change to plus when closed
        } else {
            targetElement.attr('aria-expanded', 'true');
            icon.text('-');  // Change to minus when open
        }
    }

    // Check if the URL contains an anchor and scroll to that section
    if (window.location.hash) {
        var targetElement = $(window.location.hash);  // Target either block heading or tab
        var targetTabHeader = $('.tab-header[data-target="' + window.location.hash + '"]');  // The tab header for the target

        // If the target is a valid element, scroll to it
        if (targetElement.length) {
            // If the target is a block heading, scroll to it
            if (targetElement.hasClass('wp-block-heading')) {
                scrollToElement(targetElement);
            }

            // If the target is a tab, scroll to its subject (not the whole tab)
            if (targetTabHeader.length) {
                // Scroll to the tab subject text (the tab header itself)
                scrollToElement(targetTabHeader);
                
                // After scrolling, simulate a click to expand the tab content
                setTimeout(function() {
                    openTab(targetTabHeader);
                }, 500); // Delay to allow scroll to complete first
            }
        }
    }

    // Handle anchor link behavior for block headings and tab headers separately
    $('a[href^="#"]').on('click', function(event) {
        var target = $(this).attr('href');
        var targetElement = $(target); // Get the target element

        // If the target is a block heading (not a tab), scroll to it
        if (targetElement.length && targetElement.hasClass('wp-block-heading')) {
            event.preventDefault(); // Prevent default anchor behavior for block heading
            scrollToElement(targetElement);
        } else if (targetElement.length && targetElement.hasClass('tab-header')) {
            // If it's a tab header, we'll handle the tab-specific logic
            event.preventDefault();  // Prevent the default anchor behavior
            scrollToElement(targetElement);  // Scroll to the tab header
            setTimeout(function() {
                openTab(targetElement);  // Expand the tab after scrolling
            }, 500);  // Delay to allow scroll to complete first
        }
    });

    // Toggle content when clicking the tab header
    $('.tab-header').on('click', function() {
        var target = $(this).data('target');
        var icon = $(this).find('.tab-toggle-icon');  // Find the plus/minus icon
        var isExpanded = $(this).attr('aria-expanded') === 'true';

        // Toggle the tab content and the aria-expanded attribute
        $(target).toggle();
        $(this).toggleClass('expanded');
        
        // Toggle the icon between plus and minus
        if (isExpanded) {
            $(this).attr('aria-expanded', 'false');
            icon.text('+');  // Change to plus when closed
        } else {
            $(this).attr('aria-expanded', 'true');
            icon.text('-');  // Change to minus when open
        }
    });

    // Open the tab when the user presses "Enter" while focused on a tab header
    $('.content-tab').on('keydown', function(event) {
        // Check if the key pressed is "Enter"
        if (event.key === 'Enter' || event.keyCode === 13) {
            // Prevent the default action
            event.preventDefault();

            // Find the tab header within the content tab and open it
            var tabHeader = $(this).find('.tab-header');
            openTab(tabHeader);  // Expand or collapse the tab
        }
    });
});
